import script from "./PersonListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonListItem.vue?vue&type=script&lang=ts&setup=true"

import "./PersonListItem.vue?vue&type=style&index=0&id=52092804&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52092804"]])

export default __exports__